/**
 * Module dependencies.
 */

import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

/**
 * Export `PhoneWrapper` styled component.
 */

export const PhoneWrapper = styled.div`
  min-width: 170px;
`;

/**
 * Export `Flag` styled component.
 */

export const Flag = styled.img`
  margin-right: 8px;
  top: 2px;
  position: relative;
`;
